<template>
  <div class="checkmark-container">
    <div class="checkmark-filters-wrap">
      <div class="checkmark-box">
        <div class="checkmark-infobox">
          <div class="checkmark-infoicon">
            <v-icon color="#6caa9d" size="30px">mdi-information</v-icon>
          </div>
          <div class="filter-text">
            {{ infotext.text }}
          </div>
        </div>
        <div v-for="consentbox in consentboxes" class="checkmark-checkbox-wrap" :key="consentbox.text">
          <v-checkbox
            color="teal"
            light
            :name="consentbox.text"
            :id="consentbox.inputInterpretationContext.variableName"
            :label="consentbox.text"
            ref="consentbox.text"
            @change="validateGoNext()"
          />
          <p>
            <a :href="consentbox.link.href" target="_blank"> {{ consentbox.link.text }}</a>
          </p>
        </div>
      </div>
    </div>
    <div class="checkmark-btns-wrap">
      <v-btn @click="submitAnswer(false)" :disabled="userCanGoNext" depressed block class="primary-txt-btn __h68">{{
        buttons.submit
      }}</v-btn>
      <v-btn depressed @click="submitAnswer(true)" block class="grey-txt-btn __h68" v-show="!hideCancelbutton">{{
        buttons.secondary
      }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infotext: {
        text: "DEF auswählen",
        _meta: "lorem ipsum meta information",
      },
      consentboxes: [
        {
          text: "faltbar",
          inputInterpretationContext: {
            variableName: "foldable",
            evaluationLogic: "checkboxToBoolTrue",
          },
          validation: {
            required: false,
          },
        },
        {
          text: "besonders leicht",
          inputInterpretationContext: {
            variableName: "lightweight",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
        {
          text: "sehr belastbar",
          inputInterpretationContext: {
            variableName: "forHeavyUser",
            evaluationLogic: "checkboxToBoolTrue",
          },
        },
      ],
      buttons: {
        submit: "Auswahl bestätigen",
        secondary: "Alle ansehen",
      },
      hideCancelbutton: false,
      userCanGoNext: true,
    }
  },
  methods: {
    submitAnswer(skip) {
      // go through every checkbox variable and assign true/false
      let newInput = {
        consentboxes: {},
      }

      for (let consentbox of this.consentboxes) {
        if (skip === false) {
          newInput.consentboxes[consentbox.inputInterpretationContext.variableName] =
            document.getElementById(consentbox.inputInterpretationContext.variableName).ariaChecked == "true" // cast string to bool
        } else {
          // if user skips question, assign all variables to false
          newInput.consentboxes[consentbox.inputInterpretationContext.variableName] = false
        }
      }

      this.$emit("submitAnswer", newInput)
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Checkmark Box")
      this.infotext = executableSystemAction.guiTemplateContent.infotext
      this.consentboxes = executableSystemAction.guiTemplateContent.consentboxes
      this.buttons.submit = executableSystemAction.guiTemplateContent.buttons.submit.text
      this.buttons.secondary = executableSystemAction.guiTemplateContent.buttons.secondary.text
      this.hideCancelbutton = executableSystemAction.guiTemplateContent.buttons.secondary.hidden
    },
    // validates if all required checkmarkboxes are ticked (if validation is configured)
    validateGoNext() {
      let passed = false
      for (const box of this.consentboxes) {
        if (
          box.validation?.required === true &&
          document.getElementById(box.inputInterpretationContext.variableName).ariaChecked == "true"
        ) {
          passed = true
          break
        }
      }
      this.userCanGoNext = passed
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
}
</script>
